import React from "react";
import { Rating } from "react-simple-star-rating";
import { Link, useLocation } from "react-router-dom";
import prodcompare from "../images/prodcompare.svg";
import wish from "../images/wish.svg";
import watch from "../images/watch.jpg";
import watch1 from "../images/smart-watch1.jpg";
import addcart from "../images/add-cart.svg";
import view from "../images/view.svg";

const formatPrice = (price) =>
  new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: "KES",
    maximumFractionDigits: 0,
  }).format(Number(price) || 0);

const ProductCard = ({ grid, data }) => {
  const location = useLocation();

  if (!data) return null;

  const wrapperClass =
    location.pathname === "/product" ? `gr-${grid}` : "col-3";

  const image1 = data.images?.[0]?.url || watch;
  const image2 = data.images?.[1]?.url || data.images?.[0]?.url || watch1;

  return (
    <div className={wrapperClass}>
      <div className="product-card position-relative">
        <div className="wishlist-icon position-absolute" style={{ zIndex: 2 }}>
          <button
            type="button"
            className="border-0 bg-transparent"
            aria-label="Add to wishlist"
          >
            <img src={wish} alt="wishlist" />
          </button>
        </div>

        <div className="product-image">
          <img src={image1} className="img-fluid" alt={data.title} />
          <img src={image2} className="img-fluid" alt={data.title} />
        </div>

        <div className="product-details">
          <h6 className="brand">{data.brand}</h6>
          <h5 className="product-title">
            <Link to={`/product/${data._id}`} className="stretched-link">
              {data.title}
            </Link>
          </h5>
          <Rating
            initialValue={Number(data.totalrating) || 0}
            allowFraction={true}
            readonly={true}
            size={24}
            fillColor="#ffd700"
            emptyColor="#ccc"
          />
          <div
            className={`description ${grid === 12 ? "d-block" : "d-none"}`}
            dangerouslySetInnerHTML={{ __html: data.description }}
          />
          <p className="price">{formatPrice(data.price)}</p>
        </div>

        <div className="action-bar position-absolute" style={{ zIndex: 2 }}>
          <div className="d-flex flex-column gap-15">
            <button
              type="button"
              className="border-0 bg-transparent"
              aria-label="Compare"
            >
              <img src={prodcompare} alt="compare" />
            </button>
            <button
              type="button"
              className="border-0 bg-transparent"
              aria-label="Quick view"
            >
              <img src={view} alt="view" />
            </button>
            <button
              type="button"
              className="border-0 bg-transparent"
              aria-label="Add to cart"
            >
              <img src={addcart} alt="addcart" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;

/*import React from "react";
import { Rating } from "react-simple-star-rating";
import { Link, useLocation } from "react-router-dom";
import prodcompare from "../images/prodcompare.svg";
import wish from "../images/wish.svg";
// import wishlist from "../images/wishlist.svg";
import watch from "../images/watch.jpg";
import watch1 from "../images/smart-watch1.jpg";
import addcart from "../images/add-cart.svg";
import view from "../images/view.svg";

const ProductCard = (props) => {
  const { grid } = props;
  let location = useLocation();

  return (
    <>
      <div
        className={`${
          location.pathname === "/product" ? `gr-${grid}` : "col-3"
        }`}
      >
        <Link
          to={`${
            location.pathname === "/"
              ? "/product/:id"
              : location.pathname === "/product/:id"
                ? "/product/:id"
                : ":id"
          }`}
          className="product-card position-relative"
        >
          <div className="wishlist-icon position-absolute">
            <button className="border-0 bg-transparent">
              <img src={wish} alt="wishlist" />
            </button>
          </div>
          <div className="product-image">
            <img src={watch} className="img-fluid" alt="smartwatch" />
            <img src={watch1} className="img-fluid" alt="smart watch" />
          </div>
          <div className="product-details">
            <h6 className="brand">Havels</h6>
            <h5 className="product-title">
              Kids headphones bulk 10 pack multi colored for students
            </h5>
            <Rating
              initialValue={4.5}
              allowFraction={true}
              readonly={true}
              size={24}
              fillColor="#ffd700"
              emptyColor="#ccc"
            />
            <p className={`description ${grid === 12 ? "d-block" : "d-none"}`}>
              Smart Watch with Alexa Built-in, 1.83" HD Touchscreen, Digital
              Bluetooth Calling, IP68 Waterproof Fitness Tracker, 120+ Sports
              Modes, 24/7 Heart Rate/Sleep Monitor for iPhone Android (Black)
            </p>
            <p className="price">$100.00</p>
          </div>
          <div className="action-bar position-absolute">
            <div className="d-flex flex-column gap-15">
              <button className="border-0 bg-transparent">
                <img src={prodcompare} alt="compare" />
              </button>
              <button className="border-0 bg-transparent">
                <img src={view} alt="view" />
              </button>
              <button className="border-0 bg-transparent">
                <img src={addcart} alt="addcart" />
              </button>
            </div>
          </div>
        </Link>
      </div>
      <div
        className={`${
          location.pathname === "/product" ? `gr-${grid}` : "col-3"
        }`}
      >
        <Link
          to={`${
            location.pathname === "/"
              ? "/product/:id"
              : location.pathname === "/product/:id"
                ? "/product/:id"
                : ":id"
          }`}
          className="product-card position-relative"
        >
          <div className="wishlist-icon position-absolute">
            <Link>
              <img src={wish} alt="wishlist" />
            </Link>
          </div>
          <div className="product-image">
            <img src={watch} className="img-fluid" alt="smartwatch" />
            <img src={watch1} className="img-fluid" alt="smart watch" />
          </div>
          <div className="product-details">
            <h6 className="brand">Havels</h6>
            <h5 className="product-title">
              Kids headphones bulk 10 pack multi colored for students
            </h5>
            <Rating
              initialValue={4.5}
              allowFraction={true}
              readonly={true}
              size={24}
              fillColor="#ffd700"
              emptyColor="#ccc"
            />
            <p className={`description ${grid === 12 ? "d-block" : "d-none"}`}>
              Smart Watch with Alexa Built-in, 1.83" HD Touchscreen, Digital
              Bluetooth Calling, IP68 Waterproof Fitness Tracker, 120+ Sports
              Modes, 24/7 Heart Rate/Sleep Monitor for iPhone Android (Black)
            </p>
            <p className="price">$100.00</p>
          </div>
          <div className="action-bar position-absolute">
            <div className="d-flex flex-column gap-15">
              <button className="border-0 bg-transparent">
                <img src={prodcompare} alt="compare" />
              </button>
              <button className="border-0 bg-transparent">
                <img src={view} alt="view" />
              </button>
              <button className="border-0 bg-transparent">
                <img src={addcart} alt="addcart" />
              </button>
            </div>
          </div>
        </Link>
      </div>
    </>
  );
};

export default ProductCard;*/
